import { Redirect } from "@wff/libs/i18n/redirect";

export default Redirect;
